import numeral from "numeral";

export function currencyFormatter(value, format = "$ 0,0.[00]") {
  return numeral(value ?? 0).format(format);
}

export function decimalFormatter(value, format = "0,0.[00]") {
  return numeral(value ?? 0).format(format);
}

export function percentageFormatter(value, format = "0,0.[00]%") {
  return numeral(value ?? 0).format(format);
}

export function amountScaleFormatter(value, format = "0,0.[00] a") {
  const numericValue = Number(value ?? 0);
  const absoluteValue = Math.abs(numericValue);

  if (absoluteValue >= 1000000) {
    return numeral(numericValue).format(format);
  }

  return numeral(numericValue).format("0,0.[00]");
}
